import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import NewsCard from 'sealink/react-components/news-card';

const NewsCardsCarousel = ({ newsEntries }) => (
  <div className="category-cards-carousel">
    <Swiper
      simulateTouch
      slidesPerView={1.3}
      spaceBetween={24}
      breakpoints={{
        992: {
          slidesPerView: 3,
        },
      }}
    >
      {newsEntries.map((entry, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <SwiperSlide key={index}>{NewsCard(entry)}</SwiperSlide>
      ))}
    </Swiper>
  </div>
);

export default NewsCardsCarousel;

NewsCardsCarousel.propTypes = {
  newsEntries: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      previewImage: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
      }),
      url: PropTypes.string.isRequired,
      previewText: PropTypes.string.isRequired,
      postDate: PropTypes.string.isRequired,
    })
  ),
};
